import { OverlayLoader } from 'components/Loaders'
import formName from 'constants/formName'
import { TwoFactorFormType } from 'data/types'
import * as React from 'react'
import { reduxForm } from 'redux-form'
import styled from 'styled-components'

import preventUserInputCss from '../Modal/PreventUserInput'
import DisplayCodes from './DisplayCodes'
import EnableSuccess from './EnableSuccess'
import GenerateNewCodes from './GenerateNewCodes'
import { Props as ContainerProps } from './index'
import Method from './Method'
import Setup from './Setup'
import TurnOff from './TurnOff'
import VerifyPassword from './VerifyPassword'
import VerifyTotp from './VerifyTotp'

const stepComponent = {
  disabletotp: VerifyTotp,
  displaycodes: DisplayCodes,
  enablesuccess: EnableSuccess,
  enabletotp: VerifyTotp,
  generatenewcodes: GenerateNewCodes,
  method: Method,
  setup: Setup,
  turnoff: TurnOff,
  verifypassword: VerifyPassword,
  verifytwofactor: VerifyTotp
}

type Props = ContainerProps

const Form = styled.form<{ isLoading: boolean }>`
  ${preventUserInputCss};
`

const TwoFactorForm = (props: Props) => {
  const Step = stepComponent[props.step]

  return (
    <Form isLoading={props.isLoading} onSubmit={props.handleSubmit}>
      {/* @ts-ignore FIXME add proper typings to stepComponent */}
      <Step {...props} />

      {props.isLoading && <OverlayLoader />}
    </Form>
  )
}

export default reduxForm<TwoFactorFormType, ContainerProps>({
  form: formName.TWO_FACTOR
})(TwoFactorForm)
